import { render, staticRenderFns } from "./DeleteProfileList.vue?vue&type=template&id=69690d82&scoped=true"
import script from "./DeleteProfileList.vue?vue&type=script&lang=ts"
export * from "./DeleteProfileList.vue?vue&type=script&lang=ts"
import style0 from "./DeleteProfileList.vue?vue&type=style&index=0&id=69690d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69690d82",
  null
  
)

export default component.exports